import React, { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { ShieldCheck, X } from 'lucide-react';

export function LicenseAttributionModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 text-left">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-[#020d1a]/85 backdrop-blur-md"
          />
          
          {/* Modal Box */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", duration: 0.4 }}
            className="relative w-full max-w-3xl bg-[#091526] border border-slate-800 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh] z-10"
          >
            {/* Header */}
            <div className="p-6 border-b border-slate-800 flex items-center justify-between bg-black/20 shrink-0">
              <div className="flex items-center space-x-2.5">
                <ShieldCheck className="w-5 h-5 text-[#b9e612]" />
                <h3 className="text-sm font-black text-white uppercase tracking-widest">
                  WBL PORTAL: LICENSE ATTRIBUTION
                </h3>
              </div>
              <button
                onClick={onClose}
                className="p-1.5 hover:bg-slate-800 text-slate-400 hover:text-white rounded-lg transition-colors cursor-pointer"
                title="Close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            
            {/* Body */}
            <div className="p-6 md:p-8 overflow-y-auto text-slate-300 text-xs md:text-sm leading-relaxed space-y-6 antialiased text-left">
              <p>
                This platform incorporates data derived from the O*NET 30.0 Database, provided by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA). 
                The O*NET information is utilized under the CC BY 4.0 license. O*NET® is a registered trademark of the USDOL/ETA.
              </p>
            </div>
          </motion.div>
        </div>
    </AnimatePresence>
  );
}
